import { connect } from "react-redux";
import Equipment from "./equipment";
import { onList, onAdd, onSave, onRemove } from "../actions";

const mapStateToProps = (state) => ({
	equipment: state.equipment?.data || [],
	isLoadingList: state.equipment?.isLoadingList || false,
});

const mapDispatchToProps = {
	onList,
	onAdd,
	onSave,
	onRemove,
};

export default connect(mapStateToProps, mapDispatchToProps)(Equipment);
